import { unref } from 'vue';
import { useMapGetter } from 'dashboard/composables/store';
import { useAccount } from 'dashboard/composables/useAccount';
import { useConfig } from 'dashboard/composables/useConfig';
import { INSTALLATION_TYPES } from 'dashboard/constants/installationTypes';
import {
  getUserPermissions,
  hasPermissions,
} from 'dashboard/helper/permissionsHelper';

export function usePolicy() {
  const user = useMapGetter('getCurrentUser');
  const isOnChatwootCloud = useMapGetter('globalConfig/isOnChatwootCloud');

  const { accountId, currentAccount } = useAccount();
  const { isEnterprise } = useConfig();

  const getUserPermissionsForAccount = () => {
    return getUserPermissions(user.value, accountId.value);
  };

  const isFeatureFlagEnabled = featureFlag => {
    if (!featureFlag) return true;
    if (user.value?.type === 'SuperAdmin') return true;
    return currentAccount.value?.features?.[featureFlag] === true;
  };

  const checkPermissions = requiredPermissions => {
    if (!requiredPermissions || !requiredPermissions.length) return true;
    const userPermissions = getUserPermissionsForAccount();
    return hasPermissions(requiredPermissions, userPermissions);
  };

  const checkInstallationType = installationTypes => {
    if (!Array.isArray(installationTypes) || !installationTypes.length) {
      return true;
    }

    const installationCheck = {
      [INSTALLATION_TYPES.CLOUD]: isOnChatwootCloud.value,
      [INSTALLATION_TYPES.ENTERPRISE]: isEnterprise,
      [INSTALLATION_TYPES.COMMUNITY]: true,
    };

    return installationTypes.some(type => installationCheck[type]);
  };

  const shouldShow = (featureFlag, permissions, installationTypes) => {
    const perms = unref(permissions);
    const installation = unref(installationTypes);
    return (
      isFeatureFlagEnabled(featureFlag) &&
      checkPermissions(perms) &&
      checkInstallationType(installation)
    );
  };

  const shouldShowPaywall = () => false;

  return {
    checkInstallationType,
    checkPermissions,
    shouldShowPaywall,
    isFeatureFlagEnabled,
    shouldShow,
  };
}
